(function () {
  'use strict';
  var gate = document.getElementById('rd-email-access-gate');
  var form = document.getElementById('rd-email-access-form');
  if (!gate || !form) return;
  var emailInput = document.getElementById('rd-access-email');
  var submit = document.getElementById('rd-access-submit');
  var message = document.getElementById('rd-access-message');
  var pendingUrl = null;
  var isHome = document.body.classList.contains('template-index');

  function showGate(url) {
    pendingUrl = url || null;
    document.documentElement.classList.add('rd-access-locked');
    gate.setAttribute('aria-hidden', 'false');
    gate.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    if (emailInput) emailInput.focus({ preventScroll: true });
  }
  function unlock() {
    try { sessionStorage.setItem('rd_email_access_granted', 'yes'); } catch (e) {}
    document.documentElement.classList.remove('rd-access-locked');
    gate.setAttribute('aria-hidden', 'true');
    gate.style.display = 'none';
    document.body.style.overflow = '';
    if (pendingUrl) window.location.href = pendingUrl;
  }

  // The landing page is viewable without an email. Any navigation or form action
  // that would take a visitor beyond the landing page requires email submission.
  if (isHome) {
    function hasAccess() {
      try { return sessionStorage.getItem('rd_email_access_granted') === 'yes'; } catch (e) { return false; }
    }
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (hasAccess()) return;
      var target = event.target;
      var link = target && target.closest ? target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href) || /^mailto:/i.test(href) || /^tel:/i.test(href)) return;
      var url;
      try { url = new URL(link.href, window.location.href); } catch (e) { return; }
      if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showGate(url.href);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target === form || hasAccess()) return;
      var targetForm = event.target;
      if (!targetForm || !targetForm.action) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showGate(targetForm.action);
    }, true);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    message.textContent = '';
    var email = (emailInput.value || '').trim();
    if (!emailInput.checkValidity() || !email) {
      message.textContent = 'Please enter a valid email address.';
      emailInput.focus();
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Submitting…';
    var payload = new URLSearchParams();
    payload.set('form_type', 'customer');
    payload.set('utf8', '✓');
    payload.set('contact[email]', email);
    payload.set('contact[tags]', 'newsletter, website-access');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'text/html' },
      body: payload.toString(), credentials: 'same-origin', redirect: 'follow'
    }).then(function (response) {
      if (!response.ok) throw new Error('Submission failed');
      unlock();
    }).catch(function () {
      message.textContent = 'We couldn’t submit your email right now. Please try again.';
      submit.disabled = false;
      submit.textContent = 'Continue';
    });
  });
  if (document.documentElement.classList.contains('rd-access-locked')) {
    document.addEventListener('DOMContentLoaded', function () {
      if (emailInput) emailInput.focus({ preventScroll: true });
    });
  }
}());
